<template>
    <div id="OverviewAllname">
        <div id="right">
            <div id="switchingroom">
                <div class="right-title">
                    <div id="siteswitch">
                        <div id="head">
                            <img :src="seat ? seat : seat1" alt="" />
                        </div>
                        <div id="siteswitch-title">
                            <div id="title-one">
                                <h2 id="title-name">{{ KJallName}}</h2>
                                <Garden @arrshow="arrshow" :transformerCapacity="transformerCapacity"></Garden>
                            </div>
                            <Switchsite></Switchsite>
                        </div>
                    </div>
                </div>
                <div id="oC">
                    <p>
                        <span>{{ quer }}</span>
                    </p>
                    <div></div>
                    <p>{{ temperature }}℃</p>
                    <div></div>
                    <p>
                        <span>湿度:{{ humidity}}%</span>
                    </p>
                </div>
                <div id="electricquantity">
                    <div id="one">
                        <!-- <el-popover placement="bottom-start" width="276" trigger="hover"> -->
                            <!-- <div class="popover" style="padding: 10px; display: flex; font-size: 14px;">
                                <div class="popoverf" style="   line-height: 25px;color: #0d94ff; font-weight: 400">
                                    负荷率:
                                    <span
                                        style="color: #666666;">是反映提供、用电设备是否得到充分利用的重要技术经济指标之一。从经济运行方面考虑，负荷率越接近100%，表明设备利用程度越好，用电越经济。<br>日均负荷率=(日负荷曲线的平均值/日负荷曲线的最大值)*100%</span>
                                </div>
                            </div> -->
                            <div id="loadrate" slot="reference">
                                <p class="record-item">今日用电量</p>
                                <!-- <p v-if="Realtime != 'undefined'" class="record-op" style="color:#68D86A"> -->
                                    <p class="record-op" style="color:#68D86A">
                                    <!-- :style="
                    'color:' +
                      (fuhelv <= 10
                        ? '#F5AA00'
                        : fuhelv <= 80
                        ? '#68D86A'
                        : '#fd4238') -->
                                    {{powerTotaldata}}
                                    <!-- 前端计算负荷率 -->
                                    <!-- {{ parseFloat(load) }} -->
                                    <!-- //后端计算负荷率 -->
                                    <!-- {{ fuhelv }} -->
                                    <span> kWh</span>
                                    <!-- <span id="nbsp">{{ numer }}</span> -->
                                </p>
                            </div>
                        <!-- </el-popover> -->
                        <div id="loadrate">
                            <p class="record-item">装机总容量</p>
                            <!-- <p class="record-op" v-if="isclick > 0">--</p> -->
                            <div class="record-op">
                                {{ transformerCapacity }}
                                <span>kVA</span>

                                <!-- //注释变压器数量不显示 -->
                                <!-- <p class="tran" v-if="transformerNum > 1">
                  <span class="chen">×</span>{{ transformerNum }}
                </p> -->
                            </div>
                        </div>
                        <div id="loadrate">
                            <p class="record-item">实时负载</p>
                            <p class="record-op">
                                {{ parseFloat(Realtime) }}
                                <span>kW</span>
                            </p>
                        </div>
                        <div id="loadrate" v-if="$store.state.project.currentProject.projectId == 4">
                            <p class="record-item">申报需量</p>
                            <p class="record-op">
                                {{ Demand }}
                            </p>
                        </div>
                        <div id="loadrate" v-else>
                            <p class="record-item">网关在线状态</p>
                            <div class="record-op">
                                <p>
                                    {{
               Ebox
                  }}
                                </p>
                                <div class="op2">/{{ gatewayall.length }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div id="runningstatus" v-if="latest.type != '网关断开连接'"> -->
            <div id="runningstatus" v-if="loadRank.length>0">
                <div class="runningstatus-clkbox">
                    <h3>负荷排名</h3>
                    <div class="runningstatus-jk">
                        <el-checkbox-group v-model="checkboxGroup">
                            <el-checkbox label="进线" class="myRedCheckBox" :text-color="colors"></el-checkbox>

                            <el-checkbox label="馈线" class="myRedCheckBox1" :text-color="colorp"></el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <ul id="runningstatus-ul">
                    <li class="runningstatus-li" v-for="(item, index) in watAll" :key="index">
                        <!-- 判断*1000大于零的才显示 -->
                        <!-- v-if="(parseFloat(( item.p / 1000).toFixed(2)))>0" -->
                        <div class="li-div">
                            <div>
                                {{ index + 1 }}.{{ item.loopName }}:
                            </div>
                            <div class="kong"></div>
                            <div>
                                {{ item.p }}<span>kW</span>
                            </div>
                        </div>
                        <!-- v-if="!isNaN(parseInt(Number(item.p / 30000) * 100))" -->
                        <el-progress :color="item.deviceId" :percentage="Number(item.p / maxLoadRank) * 100">
                        </el-progress>
                    </li>
                    <div class="plice" v-if="watAll == 0">请选择进线或者馈线</div>

                </ul>
            </div>
            <!-- //网关断开连接状态 -->
            <div id="runningstatus" v-else>

                <div class="runningstatus-clkbox">
                    <h3>负荷排名</h3>
                    <div class="runningstatus-jk">
                        <el-checkbox-group v-model="checkboxGroup">
                            <el-checkbox label="进线" class="myRedCheckBox" :text-color="colors"></el-checkbox>

                            <el-checkbox label="馈线" class="myRedCheckBox1" :text-color="colorp"></el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>

                <ul id="runningstatus-ul">
                    <div class="plice">暂未获取到数据</div>
                </ul>
            </div>
            <TotalAll></TotalAll>
        </div>
    </div>
</template>
<script>
    import Garden from "./garden";
    import Switchsite from "../../HomePageOverview/components/Switchsite";
    import {
        chainIndex
    } from "../../../api/linkindex";

    import {
        subscribe,
        unsubscribe,

    } from "../../../mqtt/index";
    
    import {
        powertotal
    } from "../../../api/power";
    import {
        perDay,
        perMonth,
        perYear,
        nextDay,
        nextMonth,
        nextYear,
        dateFormat,
        dayStart,
        dayEnd,
    } from "../../../util/DateUtil";
    import TotalAll from "./totalAll";
    //进线馈线
    const Wire = {
        IN: "进线",
        OUT: "馈线",
    };
    import {
        EnterpriseBackground
    } from "../../../api/backstageManagement";
    export default {
        name: "OverviewAll",
        props: {
            data: Object,
            percentage: String,
        },
        data() {
            return {
                All:[],
                //最大值
                numMax: 0,
                //标题名字
                KJallName: "--",
                //数值
                // numerical: "--",
                //颜色

                colors: "#FF9D4D",
                colorp: "#B0E6FF",
                //进线馈线
                checkboxGroup: ["进线", "馈线"],
                //负荷率
                t: "",
                loadRate: "--",
                fuhelv: "--",
                //网关总数
                gatewayall: [],
                //实时负载
                Realtimeload: "--",
                transformerCapacity: "--", //变压器容量
                transformerNum: "--", //变压器台数
                transformerLoop:[],
                //申报需量
                Demand: "- -",
                loopseat: [],
                loopsUrl: [],
                seat: "",
                seat1: require("../../../assets/img/ebs.png"),
                timeNow: 0, //时间
                oImgect: 0, //图片显示隐藏,
                quer: "", //天气
                temperature: "", //湿度
                humidity: "", //温度
                totalLoop: [],
                customColor: "#909399",
                id: 2,
                today: "",
                event: [],
                userid: "",
                abc: 0,
                powerTotaldata:"",
                list: {
                    one: [{
                            id: 1,
                            class: "负荷率",
                            data: 0, //对
                            sign: "%",
                            colorBack: "1",
                        },
                        {
                            id: 2,
                            class: "变压器容量",
                            data: "", //受电容量
                            sign: "kVA",
                            tow: "×2",
                        },
                        {
                            id: 3,
                            class: "实时负载",
                            data: 0, // this.$store.getters.mqttVal('CX/ZTR14/P'), //对
                            sign: "kW",
                        },
                        {
                            id: 4,
                            class: "变压器台数",
                            data: "",
                        },
                    ],
                },
            };
        },
        watch: {
            timeNow(n, o) {
                // console.log(this.timeNow);
                this.timeNow = n;
            },
            loopsUrl(n, o) {
                // console.log(n, o);
                subscribe(n);
                unsubscribe(o);
                // this.siteId();
            },
            "$store.state.homeitem.mqqtitem"(n, o) {
                subscribe([n]);
                unsubscribe([o]);
            },
            // "$store.getters.mqttVal"(n, o) {
            //   subscribe([n]);
            //   unsubscribe([o]);
            // },
            // $store(n, o) {
            //   subscribe([n]);
            //   unsubscribe([o]);
            // },
            "$store.state.project.projectInfo.projectCoordinate"(n,o){
                this.getWeatherInfo();
            },
        },
        created() {
            this.siteId();
            this.parkAll();
            this.howtall();
            // this.getWeatherInfo();
            this.CircuitLoop();
            this.dianya()
        },
        mounted() {
            this.t = setInterval(() => {
                this.Fhl();
            }, 30000);
            this.Fhl();
            this.siteId();
            this.parkAll();
            this.howtall(); 
            setTimeout(e=>{
                this.getWeatherInfo();
            },1000)
            this.CircuitLoop();
            this.getpower();

        },
        beforeDestroy() {
            clearInterval(this.t);
            this.parkAll();
        },
        computed: {

            Ebox() {
                if( this.gatewayall.length>0){
                     this.gatewayall.map(item=>{
                       let code=JSON.parse(item.device_details)
                    this.All.push(code.设备地址.code)
        // console.log(this.All,this.$store.state.project.projectInfo)
                     })
                }
               
                let a = this.$store.getters
                    .eBoxInfo().filter(
                        (item) => item.online && this.All.includes(item.deviceId)
                     
                    )
                console.log(a)
                return a.length
            },
            latest() {
                var recordTime = Date.parse(this.$store.getters.latest.start); //记录时间
                this.timeNow = recordTime;
                return this.$store.getters.latest;
            },
            loadRank() {
                if (!this.totalLoop) {
                    return;
                }
                // console.log(this.totalLoop)
                let abc = this.totalLoop.map((loop) => {
                    // console.log(loop);
                    subscribe([loop.subLoopUrl + "/P"]);
                    let p = this.$store.getters.mqttVal(loop.subLoopUrl + "/P");

                    //颜色区分
                    // console.log(p)
                    let c = "#FF9D4D";
                    let b = "#B0E6FF";
                    if (loop.loopType.match("OUT") !== null) {
                        loop.deviceId = b;
                    } else {
                        loop.deviceId = c;
                    }
                    // console.log(p)
                    loop.p = p ? p : 0;
                    if (loop.loopName.includes("9合1传感器")) {
                        return 0;
                    }
                    if (loop.loopName.includes("变压器状态回路")) {
                        return 0;
                    }
                    loop.p = parseFloat((p / 1000).toFixed(2))
                    return loop;
                });
                return abc
                    .filter((item) => {
                        if (item.p > 0) {
                            return item;
                        }
                    })
                    .sort((a, b) => {
                        return b.p - a.p;
                    });
            },

            // 实时负载
            Realtime() {
                if (this.transformerLoop.lenth == 0) {
                    return;
                } else {
                    // console.log(this.loopsUrl);
                    let abc = this.transformerLoop
                        .map((item) => (this.$store.getters.mqttVal(item + "/P") * 1) / 1000)
                        .reduce(
                            (prev, current) => (prev ? prev : 0) + (current ? current : 0),
                            0
                        )
                        .toFixed(2);
                    return abc;
                }
            },
            //负荷率
            load() {
                if (this.$store.state.project.currentProject.projectId == 2) {
                    return ((this.Realtime / this.transformerCapacity) * 100).toFixed(2);
                } else {
                    return ((this.Realtime / this.transformerCapacity / 2) * 100).toFixed(
                        3
                    );
                }
            },
            // numer() {
            //   if (this.load <= 10) {
            //     return (this.numerical = "过低");
            //   } else if (this.load <= 80) {
            //     return (this.numerical = "正常");
            //   } else {
            //     return (this.numerical = "过高");
            //   }
            // },
            //判断进线馈线
            watAll() {
                if (this.loadRank) {
                    return this.loadRank.filter((item) => {
                        if (this.checkboxGroup.includes(Wire[item.loopType])) {
                            return true;
                        }
                    });
                } else {
                    return false;
                }
            },

            //符合排名最大值
            maxLoadRank() {
                return (this.numMax = this.loadRank[0].p);
            },
            projectCoordinate(){
                return this.$store.state.project.projectInfo.projectCoordinate
            }
            
        },
        components: {
            Switchsite,
            Garden,
            TotalAll,
        },

        methods: {
            async getpower() {
                let start = dayStart(new Date())
                let end = dayEnd(new Date())
                let response = await powertotal(this.$store.state.project.currentProject.projectId,start,end);
                this.powerTotaldata = response.data.data.total.toFixed(2);
            },
            transformForData(response) {
                const {
                    code,
                    data,
                    status
                } = response.data;
                if (code !== 200 && status !== true) {
                    console.error("response error: code is not 200 or status is not true");
                    return null;
                }
                return data;
            },
            //负荷率接口请求；
            Fhl() {
                // console.log(this.$store.state.project.currentProject.projectId);
                chainIndex
                    .load(this.$store.state.project.currentProject.projectId)
                    .then((res) => {
                        if (JSON.stringify(res.data.data) != "{}") {
                            res.data.data.influxData.load.map((item) => {
                                if (item.projectId) {
                                    this.fuhelv = parseFloat(item.LoadPer.toFixed(2));
                                }
                            });
                        }
                        
                        // console.log(res.data.data.influxData);
                    });
            },
            //园区总览接口信息
            parkAll() {
                this.id = this.$store.state.project.currentProject.projectId;
                    this.seat = this.$store.state.firm.firm.firmLogo
                    this.KJallName = this.$store.state.firm.firm.firmName;
                    window.sessionStorage.setItem("idNameAll", this.KJallName);
                // EnterpriseBackground.search().then((res) => {
                //     this.seat = res.data.data.firm.firmLogo
                //     this.KJallName = res.data.data.firm.firmName;
                //     window.sessionStorage.setItem("idNameAll", this.KJallName);
                // })
                // console.log(res.data.data.project);
                //  this.seat = res.data.data.project.projectIcon;
                this.gatewayall = [];
                chainIndex
                    .gateway(this.$store.state.project.currentProject.projectId)
                    .then((res) => {
                        // console.log(res)
                        let all = res.data.data.devices
                        this.gatewayall = all.filter((item) => {

                            if (item.name == "网关设备") {
                                //  console.log(item)
                                return item;
                            }
                        });
                        //  console.log(this.gatewayall,"============>")
                    });
            },
            // // 接收参数
            arrshow(val) {
                // this.transformerCapacity = val;
                //负荷率
            },
            dianya(){
                chainIndex.bianyaqiAll(this.$store.state.project.currentProject.projectId).then((res=>{
    
                    let data = res.data.data.res ? res.data.data.res : "--"
                    console.log(data);
                    this.transformerCapacity = data;

                }))
            },
            //传参
            siteId() {
                this.id = this.$store.state.project.currentProject.projectId;
                chainIndex.loopAll(this.id).then((res) => {
                    this.loopsUrl = res.data.data.loops.map((item) => item.subLoopUrl);
                });
            },
            //变压器台数
            howtall() {
                this.id = this.$store.state.project.currentProject.projectId;
                chainIndex.transformer(1, this.id).then((res) => {
                    this.transformerNum = res.data.data.devices.length;
                    window.sessionStorage.setItem("transformer", this.transformer);
                });
            },
            getWeatherInfo() {
                fetch(
                        "https://devapi.qweather.com/v7/weather/now?location=" +
                        this.$store.state.project.projectInfo.projectCoordinate +
                        "&key=30b91a6005e04fe79c2e64fd7b915df1"
                    )
                    // fetch(
                    //         "https://devapi.qweather.com/v7/weather/now?location=" +
                    //         this.$store.state.project.projectInfo.projectCoordinate +
                    //         "&key=60c2982fcf2c41a5a15dbc4039ba2d97"
                    //     )
                    //  f57e5057927f4bc2ac109bc99ece25d2
                    .then((response) => response.json())
                    .then((json) => {
                        // console.log(json, "我是温度");
                        this.temperature = json.now.temp;
                        this.humidity = json.now.humidity;
                        this.quer = json.now.text;
                    })
                    .catch((e) => {
                        return e;
                    });
            },
            increase() {
                this.percentage += 10;
                if (this.percentage > 100) {
                    this.percentage = 100;
                }
            },
            decrease() {
                this.percentage -= 10;
                if (this.percentage < 0) {
                    this.percentage = 0;
                }
            },
            // ...mapMutations(["allip"]),
            ToName() {
                this.$router.push("accident-analysis");
            },
            //园区总览回路
            CircuitLoop() {
                // console.log(2)
                this.id = this.$store.state.project.currentProject.projectId;
                chainIndex.totalAll(this.id).then((res) => {
                    let loops = res.data.data.deviceLoops;
                    this.transformerLoop = loops.filter((l) => {
                        if(l.loopType==="TRANSFORMER"){
                            return l.subLoopUrl;
                        }
                    }).map((l) => {
                        return l.subLoopUrl;
                    });
                    let subUrlList = loops.map((l) => {
                        return l.subLoopUrl;
                    });
                    // console.log(loops,subUrlList, "所有回路");
                    this.totalLoop = loops;

                });
            },
        },
    };
</script>
<style lang="less" scoped>
    #right {
        float: left;
        margin-left: 8rem;
        background-color: rgba(0, 43, 102, 0.04);

        // background-color: #fff;
        #switchingroom {
            .w(528);
            .h(319);
            padding: 42rem 44rem 0 24rem;
            margin-bottom: 8rem;
            background-color: #ffffff;

            #oC {
                .w(250);
                display: flex;
                justify-content: space-between;
                margin-bottom: 35rem;
                color: rgba(0, 43, 102, 0.6);
                white-space: nowrap;
                padding-right: 50rem;
                font-size: 18rem;

                div {
                    margin-left: 20rem;
                }

                p:last-child {
                    .w(150);
                    display: flex;
                    justify-content: space-between;
                }
            }

            .right-title {
                display: flex;
                justify-content: space-between;

                .el-button {
                    .w(137);
                    .h(32);
                    text-align: center;
                    padding: 4rem 0;
                }
            }

            #title-one {
                display: flex;
            }

            #siteswitch {
                // .w(267);
                background-color: #ffffff;
                margin-bottom: 25rem;
                display: flex;

                #head {
                    .w(64);
                    .h(64);

                    // background-color: gray;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                #title-name {
                    font-size: 36rem;
                    font-weight: bold;
                    color: #333333;
                    margin-top: -8rem;
                    margin-left: 10rem;
    max-width: 19vw;
                    margin-bottom: 0rem;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis
                }

                // #site {
                //   margin-top: 12rem;
                //   font-size: 16rem;
                //   margin-top: 0rem;
                //   margin-left: 16rem;
                // }
            }

            #electricquantity {
                .w(460);

                #one {
                    .w(460);
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 50rem;

                    .one-item {
                        font-size: 18rem;
                    }
                }

                #two {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding-right: 18rem;

                    .two-item {
                        font-size: 18rem;
                    }
                }
            }
        }

        #runningstatus {
            .w(528);
            .h(313);
            padding: 20rem 40rem 0 24rem;
            margin-bottom: 8rem;
            background: #ffffff;
            overflow: hidden;

            h3 {
                font-size: 16rem;
            }

            ::-webkit-scrollbar {
                /*隐藏滚轮*/
                display: none;
            }

            #runningstatus-ul {
                width: 100%;
                height: 100%;
                overflow: scroll;
                position: relative;
                scrollbar-width: none;
                -ms-overflow-style: none;

                // background: rgba(0, 0, 0, 0.02);
                .runningstatus-li {
                    margin-left: 10rem;
                    margin-top: 6rem;

                    .li-div {
                        font-size: 16rem;
                        display: flex;
                        margin-bottom: 2rem;
                        color: #666666;

                        .li-div:last-child {
                            font-size: 13rem !important;
                        }

                        .kong {
                            width: 13rem;
                        }

                        span {
                            margin-left: 2rem;
                            font-size: 12rem;
                        }
                    }
                }

                .runningstatus-li:last-child {
                    margin-bottom: 40rem;
                }
            }
        }

        .temperature {
            display: flex;
            width: 100%;
            font-size: 20rem;
            margin-bottom: 20rem;
            color: #666666;

            .temperature-item {
                margin-top: 3rem;
                width: 70%;
                margin-left: 30rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-right: 20rem;
                color: #333333;
            }
        }
    }

    #list {
        display: flex;
        justify-content: space-between;
        // align-items: center;
    }

    .record-item {
        display: flex;
        // justify-content: center;
        align-items: center;
        font-size: 19rem;
        font-weight: 400;
        color: #666666;
    }

    .record-op {
        font-size: 21rem;
        font-weight: bold;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;

        // text-align: center;
        .op2 {
            font-size: 14rem;
            margin-top: 2px;
            color: rgba(0, 43, 102, 0.6);
        }

        span {
            margin-top: 2rem;
            margin-left: 3rem;
            font-size: 10rem;
        }
    }

    .colo {
        display: flex;
        padding-top: 10rem;

        span {
            margin-top: 14rem;
            margin-left: 2rem;
        }
    }

    .runningstatus-clkbox {
        display: flex;
        justify-content: space-between;
    }

    .runningstatus-jk {
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
    }

    .plice {
        // position: absolute;
        margin-top: 100rem;
        text-align: center;
        font-size: 18rem;
        color: #999999;
    }

    .tran {
        font-size: 21rem;
        color: #666666;
    }

    .chen {
        font-size: 14rem !important;
    }
</style>